import { Validator } from '@vista-digital/validator';
export const defaultSeatAppearanceConfig = {
    iconName: 'normal-seat',
    showLabels: false,
    labelOffsetX: 0,
    labelOffsetY: 0
};
export const seatAppearanceConfigValidator = Validator.object({
    iconName: Validator.nonEmptyString,
    showLabels: Validator.optional(Validator.boolean()),
    labelOffsetX: Validator.optional(Validator.number()),
    labelOffsetY: Validator.optional(Validator.number())
});
//# sourceMappingURL=seat-appearance.js.map